import React from 'react';
import { MenuItem, Select, FormControl, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const CategorySelect = ({ categories, handleOnChangeCategory, category, error, helperText }) => {
  const { t } = useTranslation();

  return (
    <FormControl error={ error } style={ { width: '100%' } }>
      <Select
        onChange={ handleOnChangeCategory }
        value={ category || '' }
        displayEmpty
      >
        <MenuItem key='0' disabled value=''>
          { t('objective.dialog.create.category.placeholder') }
        </MenuItem>
        { categories.map(category =>
          <MenuItem
            key={ category.category_id }
            value={ category }
          >
            { category.category_name.hu }
          </MenuItem>
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default CategorySelect;
